import { connectMainSocket, waitForMainSocketAuthenticated } from '../../clients/mainSocketClient'
import { socketAckErrorToError } from '../../modules/chat/socketApiErrors'

/**
 * Emit a socket event and resolve with the Socket.IO ack callback (mobile-style).
 * Used for events that share the same contract as Android/iOS (e.g. chatGroups::get).
 */
export async function emitWithCallbackAck (event, payload) {
  const socket = await connectMainSocket()

  if (!socket) {
    return Promise.reject(new Error('Socket not connected'))
  }

  await waitForMainSocketAuthenticated()

  return new Promise((resolve, reject) => {
    socket.emit(event, payload, (error, response) => {
      if (error != null && error !== false) {
        reject(socketAckErrorToError(error))
        return
      }
      resolve(response)
    })
  })
}
